import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-proformas',
  templateUrl: './proformas.component.html',
  styleUrls: ['./proformas.component.scss']
})
export class ProformasComponent   {
  Label_Proformas=environment.LABEL_PROFORMAS;
  Label_Proforma=environment.LABEL_PROFORMA;
  constructor(private loginService:LoginService) { }

  

  clickGuard(){
    this.loginService.clickGuard = true;
 }

}
